
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"80","height":"80"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 4065","transform":"translate(-1512 -295)"}},[_c('circle',{attrs:{"data-name":"Ellipse 336","cx":"40","cy":"40","r":"40","transform":"translate(1512 295)","fill":"#24f7b8","opacity":".15"}}),_c('g',{attrs:{"data-name":"buliding","stroke":"#01b982","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3"}},[_c('path',{attrs:{"d":"M1535.326 351.674h33.348","fill":"#292d32"}}),_c('path',{attrs:{"data-name":"Vector","d":"M1560.339 318.326h-16.679c-5.003 0-6.671 2.985-6.671 6.67v26.678h30.022v-26.678c0-3.685-1.668-6.67-6.672-6.67zM1543.67 342.5h4.989M1555.341 342.5h4.989M1543.67 335h4.989M1555.341 335h4.989M1543.67 327.5h4.989M1555.341 327.5h4.989","fill":"none"}})])])])
          )
        }
      }
    